import BaseProvider from './base-provider';
import { SubmissionError } from 'redux-form';
import { getPaymentData } from './helpers/wolf';

export default class WolfDataProvider extends BaseProvider {
  async register(email) {
    let res;
    try {
      res = await this._post('/v1/allsmarts_registration', { email });
    } catch (e) {
      throw new SubmissionError({ _error: 'Unexpected error. Please try again' });
    }

    if (!res.ok) throw new SubmissionError({ _error: 'Unexpected error. Please try again' });

    try {
      if (window.analytics) {
        window.analytics.identify({
          email
        });
        window.analytics.track('user_sfmc_app', {
          email,
          timestamp: new Date().toISOString()
        });

        // Segment recommends a delay between track calls and redirects
        await this.delayForAnalytics();
      }
    } catch (e) {
      // do nothing on failure
    }

    this.nativeBridge.setNewUserEmail({ email });

    return;
  }

  delayForAnalytics = async () => {
    return new Promise((res, rej) => {
      setTimeout(res, 300);
    });
  }

  closeWebview() {
    this.nativeBridge.closeWebview();
  }

  redirectToLogin() {
    this.nativeBridge.redirectToLogin();
  }

  async makePayment(paymentType, hasFreeTrial) {
    await this.nativeBridge.makePaymentFromNative(getPaymentData(paymentType, hasFreeTrial));
  }

  manualActivationCompleted() {
    this.nativeBridge.manualActivationCompleted();
  }
}
